
import Echo from 'laravel-echo';
import Pusher from 'pusher-js';
export default {
  props: {
    messageId: {
      type: Number,
      required: true,
    },
    userId: {
      type: Number,
      required: true,
    },
    isVisible: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      localIsVisible: this.isVisible,
      id: this.userId,
    };
  },
  methods: {
    async deleteMessage() {
      await this.deleteClick();
      this.closePopup();
    },

    blockUser() {
      this.$emit('block', this.userId);
      this.closePopup();
    },
    closePopup() {
      this.localIsVisible = false;
      this.$emit('close', false);
    },

    async deleteClick() {
      const data = {
        room_id: this.$route.query.groupId,
        message_id: this.messageId,
      };
      await this.$axios.post('/api/messages', data);
    },

    // blackListConnect() {
    //   if (!window.Pusher)
    //     window.Pusher = Pusher;
    //   if (!this.echo) {
    //     this.echo = new Echo({
    //       broadcaster: "pusher",
    //       key: "668bac10cc6db3a1338c",
    //       cluster: "ap3",
    //       authEndpoint: '/api/messages',
    //     });
    //   }
    //   this.echo.channel(`chats` + this.$route.query.groupId)
    //     .listen("JoinMessage", (e) => {
    //       console.log(e);
    //       if (e.group.message_type == 1) {
    //         this.$emit('messageDelete', e);
    //       }

    //     })
    // },
  },
};
